import _deTranslation from './de.json';

const translation = {
    ..._deTranslation,
};

export default translation;